import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, toRefs } from 'vue';
import { InputNumberInputEvent } from 'primevue/inputnumber';
import { useProgressReportDropdown } from '@/composables';
import ProgressReportOptions from '@/assets/json/progress_options.json';

interface Props {
  goalId: undefined | number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressReportIntensityType',
  props: {
    goalId: { default: undefined }
  },
  setup(__props: any) {

const props = __props;

const { goalId } = toRefs(props);

const intensityType = ref();

const onChange = (event: InputNumberInputEvent) => useProgressReportDropdown(goalId, 'intensity_type').onChange(event);

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Dropdown, {
      modelValue: intensityType.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((intensityType).value = $event)),
      options: _unref(ProgressReportOptions).intensity_types,
      "option-label": "name",
      "option-value": "value",
      placeholder: "Select Intensity Type",
      onChange: onChange
    }, null, 8, ["modelValue", "options"])
  ]))
}
}

})